import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const TransportShiftLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'TransportShift' */ './components/TransportShift'
		)
);

export default (store) => {
	return {
		path: 'transport-shift',
		element: <AsyncLoading component={<TransportShiftLazy />} />,
	};
};
